export const Colors = {
  /** Purple Smoke */
  purpleSmoke100: "#F9F9FC",
  purpleSmoke300: "#F3F3FA",
  /** Gray Smoke */
  graySmoke200: "#F3F2F4",
  graySmoke300: "#F2F2F2",
  graySmoke400: "#CFCDD2",
  graySmoke500: "#3E354A",
  /** -- CookUnity Color Palette -- */
  /** White */
  white: "#FFFFFF",
  /** Black */
  black: "#000000",
  black200: "#DDD",
  blackPurple: "#0E031D",
  lightBlack: "#1C1C1C",
  /** Gold */
  gold500: "#C7B273",
  /** Blue */
  blue50: "#d0efff",
  blue100: "#2a9df4",
  blue200: "#187bcd",
  blue300: "#1067b1",
  blue400: "#0a5492",
  blue700: "03254c",
  blue900: "#001132",
  /** Gray */
  gray400: "#4D4D4F",
  gray350: "#707070",
  gray300: "#A8A8A8",
  gray200: "#DDDDDD",
  gray150: "#EEEEEE",
  gray100: "#F5F5F5",

  /** Pink */
  pink500: "#DA1884",
  pink300: "#F68AC6",
  pink200: "#F8C2E0",
  /** Green */
  green200: "#E8F5EF",
  green300: "#d9eee4",
  green400: "#90bfaa",
  green500: "#199861",
  green700: "#0D6D44",
  /** Red */
  red100: "#FCDDDA",
  red200: "#FDEEEC",
  red300: "#FADFDB",
  red500: "#EE5744",
  red700: "#B63424",
  /** Orange */
  orange200: "#FEF0E8",
  orange500: "#F96715",
  orange700: "#C64B06",
  /** Purple */
  purple200: "#ebebfb",
  purple300: "#C1C1FF",
  purple500: "#3939D8",
  purple600: "#23239A",
  purple700: "#121285",
  /** Wine */
  wine700: "#6D1A42",
  wine500: "#97225A",
  wine300: "#BD4E83",
  /** Yellow */
  yellow50: "#FFFAEB",
  yellow100: "#FFEFCA",
  yellow500: "#FFC84E",
  yellow600: "#CFA144",
};

export type ColorsType = typeof Colors;
export type KeyColors = keyof ColorsType;
export interface ColorsInterface {
  color?: KeyColors;
}
